import { render, staticRenderFns } from "./InstrumentsListContainer.vue?vue&type=template&id=2d1fdcfe&scoped=true&"
import script from "./InstrumentsListContainer.vue?vue&type=script&lang=ts&"
export * from "./InstrumentsListContainer.vue?vue&type=script&lang=ts&"
import style0 from "./InstrumentsListContainer.vue?vue&type=style&index=0&id=2d1fdcfe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1fdcfe",
  null
  
)

export default component.exports